import Swal from 'sweetalert2'

const alert = Swal.mixin({})

export const Alert = (success = true, message = '', duration = 6000) => {
    let type
    if (typeof success === 'boolean') {
        type = success ? 'success' : 'error'
    } else {
        type = success
    }

    alert.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
        iconColor: 'white',
        customClass: {
            popup: 'kb-toast-popup',
            container: 'kb-toast',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
            toast.addEventListener('click', Swal.close)
        },
    })
}

export const isMobile = () => {
    return window.innerWidth < 992
}

export const toggleLockBody = () => {
    const body = document.body
    body.style.overflow = body.style.overflow === 'hidden' ? '' : 'hidden'
}
export const lockBody = () => {
    const body = document.body
    body.style.overflow = 'hidden'
}

export const unlockBody = () => {
    const body = document.body
    body.style.overflow = ''
}

export const debounce = (callback, delay) => {
    let timeout
    return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            callback.apply(this, args)
        }, delay)
    }
}
